import { useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@material-ui/core";

import { ReactComponent as Loader } from "../../../../components/LearningResources/Assement/Questions/Loader/Loader.svg";
import { GlobalContext } from "../../../../context/GlobalState";
import { examTypes, grades, subjects } from "../utils/data";

function ExamTable({
  rows = [],
  loading,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  onRowClick,
}) {
  const { userDetails } = useContext(GlobalContext);
  if (loading) return <Loader />;

  const paginatedRows = rows;

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toISOString().split("T")[0];
  };

  const formatDuration = (minutes) => {
    if (!minutes) return "-";
    return `${minutes} min`;
  };

  const getStatus = (row) => {
    if (row.isFinalPublish) return "Published";
    if (row.isProvisionalPublished) return "Provisional";
    return "Draft";
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table aria-label="exam table">
          {/* ---------- Table Head ---------- */}
          <TableHead>
            <TableRow>
              {[
                "No",
                "Test Title",
                "Subject",
                "Start Date",
                "Duration",
                "Type",
                "",
              ].map((heading) => (
                <TableCell key={heading} align="center">
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* ---------- Table Body ---------- */}
          <TableBody>
            {paginatedRows.length ? (
              paginatedRows.map((row, index) => {
                return (
                  <TableRow
                    key={row.id || index}
                    style={{
                      textDecoration: "none",
                      backgroundColor:
                        index % 2 ? "rgba(180, 107, 130, 0.15)" : "white",
                    }}
                  >
                    <TableCell align="center">{index + 1}</TableCell>

                    <TableCell align="center">{row.examName || "-"}</TableCell>

                    <TableCell align="center">
                      {subjects[row.subject - 1] || "-"}
                    </TableCell>

                    <TableCell align="center">
                      {formatDate(row.examDate)}
                    </TableCell>

                    <TableCell align="center">
                      {formatDuration(row.overallDuration)}
                    </TableCell>
                    <TableCell align="center">
                      {examTypes[row.examType - 1] || "-"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.documents?.[0]?.url ? (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <a target="_blank" href={row?.documents?.[0]?.url}>
                            <button
                              style={{
                                border: "1px solid",
                                borderRadius: "5px",
                                background: "transparent",
                                padding: "5px 20px",
                              }}
                            >
                              View Questions
                            </button>
                          </a>
                          <button
                            onClick={() => onRowClick && onRowClick(row)}
                            style={{
                              border: "1px solid white",
                              borderRadius: "5px",
                              background: "#b46b82",
                              color:"white",
                              padding: "5px",
                            }}
                          >
                            Submit/View Report
                          </button>
                        </div>
                      ) : null}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={13} align="center">
                  No exams available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* ---------- Pagination (API Controlled) ---------- */}
        <TablePagination
          component="div"
          count={rows.length}
          page={page || 0}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage || 10}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}

export default ExamTable;
